import { createContext, useContext, type FC, type ReactNode } from "react";

import type { HreflangAlternate } from "components/MetaTags/MetaTags.types";

type CmsPageNavigationContextValue = {
    hreflangAlternates?: HreflangAlternate[] | null;
};

const CmsPageNavigationContext = createContext<CmsPageNavigationContextValue>(
    {}
);

export const CmsPageNavigationProvider: FC<{
    hreflangAlternates?: HreflangAlternate[] | null;
    children: ReactNode;
}> = ({ hreflangAlternates, children }) => (
    <CmsPageNavigationContext.Provider value={{ hreflangAlternates }}>
        {children}
    </CmsPageNavigationContext.Provider>
);

export const useCmsPageNavigation = () => useContext(CmsPageNavigationContext);
